<template>
  <v-app>
    <add-card-header
      :boss40AppUrl="boss40AppUrl"
      :title="title"
      :disabledFinish="false"
      class="add-card-header"
      @save="saveCard"
      @cancel="cancel"
    ></add-card-header>

    <v-layout class="action-bars" no-gutters>
      <v-flex></v-flex>
      <v-flex xs6 class="whitebg">
          <v-select
            label="Card Type"
            :items="cardTypes"
            v-model="cardType"
            autocomplete
            v-show="showCardTypes"
          ></v-select>
      </v-flex>
      <v-flex></v-flex>
    </v-layout>
    <v-container
      class="content"
      fluid
      pa-0
      fill-height
      v-if="isAddCreditCard == false"
    >
      <v-layout row fill-height class="justify-center text-xs-center">
        <v-spacer></v-spacer>
        <v-flex xs6>
          <v-card flat>
            <v-card-text style="height:100%">
              <v-form
                v-model="valid"
                ref="savedCardForm"
                lazy-validation
                style="height:100%"
              >
                <v-layout row text-xs-left title>
                  <v-flex xs12>
                    Credit Card
                  </v-flex>
                </v-layout>
                <v-layout row fill-height align-center>
                  <v-flex class="subheading shrink fill-height">
                    <v-icon>fa-credit-card</v-icon> <strong>Saved Card:</strong>
                    {{ `${account.name} (****${lastFourDigits})` }}
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-btn color="primary" @click="openAddCreditCard" outline>
                      Change Credit Card
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-form></v-card-text
            ></v-card
          ></v-flex
        >
        <v-spacer></v-spacer></v-layout
    ></v-container>
    <v-container class="content" fluid pa-0 v-if="isAddCreditCard && cardType == 'VisaMC' && hostedTokenizationToken">
      <v-layout row class="justify-center text-xs-center">
        <add-cc-moneris-form
          ref="monerisForm"
          :hostedTokenizationToken="hostedTokenizationToken"
          @moneris-success="onMonerisSuccess"
        />
      </v-layout>
    </v-container>
    <v-container class="content" fluid pa-0 fill-height v-if="isAddCreditCard && cardType == 'AMEX'">
      <v-layout row fill-height class="justify-center text-xs-center">
        <v-flex xs3></v-flex>
        <v-flex xs6 pt-2 class="stripe-form">
          <stripe-element-card
            v-if="publishableKey"
            ref="elementRef"
            :pk="publishableKey"
            @token="tokenCreated"
            :hidePostalCode=true
          />
        </v-flex>
        <v-flex xs3></v-flex>
      </v-layout>
    </v-container>
    <add-card-footer :company="company"></add-card-footer>
  </v-app>
</template>

<script>
import axios from "axios";
import AddCardFooter from "../components/AddCard/AddCardFooter.vue";
import AddCardHeader from "../components/AddCard/AddCardHeader.vue";
import RedAsterisk from "@/components/RedAsterisk.vue";
import AddCcMonerisForm from "../components/AddCCMonerisForm.vue";
import { StripeElementCard } from '@vue-stripe/vue-stripe';

export default {
  components: {
    /* eslint-disable vue/no-unused-components */
    AddCardFooter,
    AddCardHeader,
    RedAsterisk,
    StripeElementCard,
    AddCcMonerisForm
  },
  data: () => ({
    valid: false,
    menu: false,
    cardType: "VisaMC",
    cardTypes: [
      {
        text: "VISA/MasterCard",
        value: "VisaMC"
      },
      {
        text: "American Express",
        value: "AMEX"
      }
    ],
    BAN: "",
    clientToken: "",
    myAccountToken: "",
    process: "",
    boss40AppUrl: "",
    ccNumber: "",
    ccExpiry: "",
    ccStreetNumber: "",
    ccStreetName: "",
    ccZipPostalCode: "",
    ccEmailAddress: "",
    ccName: "",
    ccPhoneNumber: "",
    account: {
      name: "",
      streetNumber: "",
      street: "",
      mailCode: "",
      email: "",
      phone: "",
    },
    showCardTypes: false,
    isSameAccountInfo: false,
    lastFourDigits: null,
    isAddCreditCard: null,
    company: { name: "Mircom", email: "" },
    token: null,
    publishableKey: null,
    cardNumber: null,
    cardExpiry: null,
    cardCvC: null,
    status: null,
    pubKey: null,
    clientSecret: null,
    monerisData: {
      payGateToken: "",
      BAN: "",
      TemporaryToken: "",
      ccPerson: {},
      ccAddress: {}
    },
    previousPaymentTypeId: null,
    boss40Account: {},
    hostedTokenizationToken: "",
  }),
  async mounted() {
    this.myAccountToken = this.$route.query.token
    this.deleteQueryString("token")
    await this.decodeMyAccountToken()
    await this.getBoss40AccountDetails()
    
    if(this.account.country == "US")
      this.showCardTypes = true;

    await axios
      .post(process.env.VUE_APP_PGAPI + "api/config/getboss40urls", {
        clientToken: this.clientToken
      })
      .then((resp) => {
        this.boss40AppUrl = resp.data.Boss40AppUrl;
      });

    await axios
      .post(process.env.VUE_APP_PGAPI + "api/values/getkey", {
        BAN: this.BAN,
        PayGateToken: this.clientToken
      })
      .then((resp) => {
        if (
          resp.data != null &&
          resp.data != "" &&
          typeof resp.data != undefined
        ) {
          this.isAddCreditCard = false;
          this.lastFourDigits = resp.data;
        } else {
          this.isAddCreditCard = true;
        }
      });
      await this.getPubKey()
      await this.getHostedTokenizationToken();
  },
  beforeDestroy(){
    this.cardNumber.destroy();
    this.cardExpiry.destroy();
    this.cardCvc.destroy();
  },
  computed: {
    miconnectRedirectApp() {
      switch (this.process) {
        case "passwordReset":
          return "tx3-password-reset";
        case "register":
          return "register";
        case "buildingManagerSignup":
          return "building-manager-signup";
        default:
          return "register";
      }
    },
    hasSavedCard() {
      return this.lastFourDigits ? true : false;
    },
    title() {
      var title = "Add Credit Card Information";
      if (this.hasSavedCard && this.isAddCreditCard == false) {
        title = "Confirm Credit Card Information";
      }
      return title;
    },
    stripeElements() {
      return this.$stripe.elements();
    },
  },
  methods: {
    onMonerisSuccess(data) {
      this.monerisData = {
        payGateToken: this.clientToken,
        BAN: this.BAN,
        TemporaryToken: data.TemporaryToken,
        ccPerson: data.ccPerson || {},
        ccAddress: data.ccAddress || {},
        PaymentMethodId: this.previousPaymentMethodId
      }
      // Now proceed with the rest of the save logic
      this.saveCardFinish();
    },
    async saveCard(){
      if (this.isAddCreditCard) {
        if (this.cardType == "VisaMC") {
          // Call the child Moneris form's submit method
          if (this.$refs.monerisForm && this.$refs.monerisForm.doMonerisSubmit) {
            this.$refs.monerisForm.doMonerisSubmit();
            // Do not proceed until onMonerisSuccess is called
            return;
          }
        }
      }
      this.saveCardFinish();
    },
    async saveCardFinish() {
      if(this.cardType == "VisaMC"){
        if (
          this.isAddCreditCard == false &&
          this.$refs.savedCardForm.validate()
        ) {
          location.assign(
            this.boss40AppUrl +
              "#/miconnect/" +
              this.miconnectRedirectApp +
              "?isCardEntered=true&cardName=" +
              this.account.name +
              "&lastDigits=" +
              this.lastFourDigits
          );
        } else {
          let cardDetails = this.monerisData;

          await axios
            .post(
              process.env.VUE_APP_PGAPI + "api/card/post",
              cardDetails
            )
            .then(async (res) => {
              this.boss40Account.paymentMethodId = "CC";
              await axios.post(process.env.VUE_APP_PGAPI + 'api/boss40/editaccount', { "account": this.boss40Account, "payGateToken": this.clientToken });
              var lastFourDigits = res.data.last4;
              location.assign(
                this.boss40AppUrl +
                  "#/miconnect/" +
                  this.miconnectRedirectApp +
                  "?isCardEntered=true&cardName=" +
                  this.ccName +
                  "&lastDigits=" +
                  lastFourDigits
              );
            })
            .catch(async (err) => {
              this.boss40Account.paymentMethodId = this.previousPaymentMethodId;
              await axios.post(process.env.VUE_APP_PGAPI + 'api/boss40/editaccount', { "account": this.boss40Account, "payGateToken": this.clientToken });
              console.log(err);
            });
        }
      }
      else if(this.cardType == "AMEX"){
        this.boss40Account.paymentMethodId = "ST";
        await axios.post(process.env.VUE_APP_PGAPI + 'api/boss40/editaccount', { "account": this.boss40Account, "payGateToken": this.clientToken })
        await this.$refs.elementRef.submit()
      }
    },
    cancel() {
      location.replace(
        this.boss40AppUrl + "#/miconnect/" + this.miconnectRedirectApp
      );
    },
    deleteQueryString(queryString) {
      let query = Object.assign({}, this.$route.query);
      delete query[`${queryString}`];
      this.$router.replace({ query });
    },
    openAddCreditCard() {
      var confirmAddCreditCard = confirm(
        "WARNING: Are you sure you would like to replace the credit card on file with a new card?"
      );
      if (confirmAddCreditCard) {
        this.isAddCreditCard = true;
      }
    },
    async decodeMyAccountToken(){
      await axios
        .post(process.env.VUE_APP_PGAPI + `api/boss40/DecodeMyAccountToken/?token=${this.myAccountToken}`)
        .then((resp) => {
          this.clientToken = resp.data.PaygateToken
          this.BAN = resp.data.AccountNumber
          this.process = resp.data.Process
          this.account.phoneNumber = resp.data.PhoneNumber
          this.account.email = resp.data.Email
          this.account.name = `${resp.data.FirstName} ${resp.data.LastName}`
          this.account.streetNumber = resp.data.StreetNumber
          this.account.street = resp.data.StreetName
          this.account.mailCode = resp.data.MailCode
          this.account.country = resp.data.Country
        });
    },
    async getPubKey() {
      let pubKey = await axios.post(process.env.VUE_APP_PGAPI + "api/values/stripepubkey", {PayGateToken: this.clientToken})
      this.publishableKey = pubKey.data
    },
    async tokenCreated (token) {
        this.token = token
        let card = {
            BAN: this.BAN,
            payGateToken: this.clientToken,
            card: this.token.id, 
            email: this.account.email,
            name: this.account.name,
            isAmex: true,
            PaymentMethodId: this.previousPaymentMethodId
        }
        await axios.post(process.env.VUE_APP_PGAPI + "api/card/post", card)
        .then(res => {
            if (res.status == 200) {
              location.assign(
                this.boss40AppUrl + 
                "#/miconnect/" + 
                this.miconnectRedirectApp + 
                "?isCardEntered=true&cardName=" + 
                this.account.name + 
                "&lastDigits=" + 
                this.token.card.last4
              );
            }
        })
        .catch((error) =>{
            console.log(error);
        });
    },
    async getBoss40AccountDetails(){
      await axios
        .post(process.env.VUE_APP_PGAPI + "api/boss40/getaccount", {"accountNumber" : this.BAN, "payGateToken" : this.clientToken })
        .then((resp) => {
          this.boss40Account = resp.data;
          this.previousPaymentMethodId = resp.data.PaymentMethodId;
        });
    },
    async getHostedTokenizationToken(){
      await axios.post(process.env.VUE_APP_PGAPI + "api/config/gethostedtokenizationtoken", {
        clientToken: this.clientToken
      }).then((resp) => {
        if (resp.data) {
          this.hostedTokenizationToken = resp.data.HostedTokenizationToken;
        }
      })
      .catch((err) => {
        console.log(err)
      });
    },
  },
};
</script>

<style scoped>
.add-card-header {
  min-height: 50px;
}
.page-title {
  font-size: x-large;
  font-weight: bold;
}
.content {
  background-color: #eae8ea;
}
.whitebg {
  background-color: white;
}
.action-bars {
  background-color: #f0f0f0 !important;
  min-height: 52px;
  max-height: 52px;
}
.card-title{
    font-family: Roboto, sans-serif;
    font-size: 20px;
}
.form-field-label{
    color: grey;
    font-family: Roboto, sans-serif;
    font-size: 12px;
}
.form-field{
    border-bottom-width: 1px;
    border-bottom-color: lightgray;
    border-bottom-style: solid;
}
.stripe-form {
  background-color: white !important;
  height: 50px !important;
}
/deep/div.v-input.v-input--selection-controls.v-input--checkbox {
  margin-top: 0px;
  padding-top: 0px;
}
</style>
